export default __webpack_public_path__ + "static/media/jj2_bg.d17332ac.png";